<template>
    <div class="row">
        <div class="col-md-12 campaign-editor__name">
            <name-section
                v-model="campaign.name"
                :validation="validation"
                :show-errors="showErrors">
            </name-section>
            <div class="row">
                <div v-show="showBankrateSelect || showIsAdvertiserEditBlocked" class="col-md-12 text-right" id="bankrate-select-checkbox" v-cloak>
                    <div class="p-r-xl" v-show="showBankrateSelect">
                        Is Bankrate Select? <input type="checkbox" v-model="campaign.is_bankrate_select">
                    </div>
                    <div class="p-r-xl" v-show="showIsAdvertiserEditBlocked">
                        Is Advertiser Edit Blocked? <input type="checkbox" v-model="campaign.is_advertiser_edit_blocked">
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 campaign-editor__ad-product" v-if="showAdProductSelect">
            <ad-product-section
                    v-model="campaign.ad_product"
                    :ad-products="dimensions.ad_products"
                    :validation="validation"
                    :show-errors="showErrors">
            </ad-product-section>
        </div>

        <div class="col-md-12" v-show="showBudget" v-cloak>
            <budget-section
                    v-model="campaign"
                    :dimensions="dimensions"
                    :validation="validation"
                    :show-errors="showErrors">
            </budget-section>
        </div>
    </div>
</template>

<script type="text/babel">
    import NameSection from './sections/name.vue'
    import AdProductSection from './sections/ad-product.vue'
    import BudgetSection from '../adsets/shared/budget.vue'

    export default {
        props: {
            value: {
                type: Object
            },
            baseUrl: {
                type: String
            },
            validation: {
                type: Object
            },
            showErrors: {
                type: Boolean
            },
            editing: {
                type: Boolean,
                default: false
            },
            hasSelectGroup: {
                type: Boolean
            },
            dimensions: {
                type: Object
            },
            userRoles: {
                type: Array
            }
        },

        data() {
            return {
                campaign: this.value,
                dateStart: {
                    time: this.value.start_date
                },
                dateEnd: {
                    time: this.value.end_date
                },
                showEndDate: false
            }
        },

        watch: {
            value(val) {
                this.campaign = val;
                this.dateStart.time = val.start_date;
                this.dateEnd.time = val.end_date;

                if (this.campaign.end_date !== '') {
                    this.showEndDate = true;
                }
            }
        },

        computed: {
            showAdProductSelect: function () {
                return this.featureFlag('campaign-ad-product-enabled');
            },
            isCostPerLeadEnabled: function() {
                return _.find(this.dimensions.ad_products,function(ad_product) {
                    return ad_product.type == 'CPL';
                }) !== undefined;
            },
            showBankrateSelect: function () {
                return this.featureFlag('campaign-bankrate-select');
            },
            showBudget: function() {
                return this.featureFlag('campaign-budget-enabled');
            },
            showIsAdvertiserEditBlocked() {
                return this.userRoles.includes('staff') || this.userRoles.includes('engineer');
            },
        },

        components: {
            NameSection,
            AdProductSection,
            BudgetSection
        }
    }
</script>

<style>
    #bankrate-select-checkbox {
        margin-top: -152px;
    }
</style>
